<template>
  <div id="cloud-plan">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="title-header">
      <span class="title" v-show="pageType===1">获取方案</span>
      <span class="title" v-show="pageType===2">申请合作</span>
      <span class="right" @click="goBackClick">返回上一步 ></span>
    </div>
    <div class="wrapper">
      <div class="section1">
        <div class="title" v-show="pageType===1">消防云-智慧消防整体解决方案申请表</div>
        <div class="title" v-show="pageType===2">消防云-智慧消防渠道合作申请表</div>
      </div>
      <div class="section2">
        <div class="htitle">
          <div class="name">公司信息</div><span class="tip"></span>
        </div>
        <div class="input-box">
          <span>公司名称</span>
          <input placeholder="请输入公司名称" type="text" maxlength="30" v-model="company_name" v-on:focus="focus()"
            v-on:blur="blur()" />
        </div>
        <div class="input-box">
          <span>主营行业</span>
          <input placeholder="请输入主营行业" type="text" maxlength="30" v-model="main_business" v-on:focus="focus()"
            v-on:blur="blur()" />
        </div>
      </div>

      <div class="section3">
        <div class="htitle">
          <div class="name">联系人信息</div><span class="tip"></span>
        </div>
        <div class="input-box">
          <span>联系人姓名</span>
          <input placeholder="请输入联系人姓名" type="text" maxlength="10" v-model="contacter" v-on:focus="focus()"
            v-on:blur="blur()" />
        </div>
        <div class="input-box">
          <span>联系人手机号</span>
          <input placeholder="请输入联系人手机号" type="text" maxlength="11" v-model="phone" v-on:focus="focus()"
            v-on:blur="blur()" oninput="value=value.replace(/[^\d]/g,'')" />
        </div>
        <div class="input-box">
          <span>验证码</span>
          <input placeholder="请输入验证码" type="text" maxlength="6" v-model="code" v-on:focus="focus()" v-on:blur="blur()"
            oninput="value=value.replace(/[^\d]/g,'')" />
          <div id="cloudCodeText" class="button" :class="codeBtnClass" v-on:click="phoneCodeClick">获取验证码</div>
        </div>
        <div class="input-box">
          <span>联系人职务</span>
          <input placeholder="请输入联系人职务(非必填)" type="text" maxlength="20" v-model="career" v-on:focus="focus()"
            v-on:blur="blur()" />
        </div>
        <div class="input-box">
          <span>其他</span>
          <input placeholder="其他(非必填)" type="text" maxlength="50" v-model="other" v-on:focus="focus()"
            v-on:blur="blur()" />
        </div>
      </div>

      <div class="section4" v-show="pageType==1">
        <div class="htitle">
          <div class="name">获取解决方案类型</div><span class="tip"> (可多选)</span>
        </div>
        <div class="check-box" v-for="(value,index) in typeswork" :key="index" v-on:click='typeClick(value)'>
          <img :src="value.isSel===1?msgImg_s:msgImg_n" />
          <span>{{value.title}}</span>
        </div>
      </div>

      <div class="section4" v-show="pageType==2">
        <div class="htitle">
          <div class="name">期待合作类型</div><span class="tip2"> (可多选)</span>
        </div>
        <div class="check-box" v-for="(value,index) in typesplan" :key="index" v-on:click='typeClick(value)'>
          <img :src="value.isSel===1?msgImg_s:msgImg_n" />
          <span>{{value.title}}</span>
        </div>
      </div>

      <div class="section5">
        <div class="htitle" v-show="pageType==1">
          <div class="name">留言及疑问</div><span class="tip"></span>
        </div>
        <div class="htitle" v-show="pageType==2">
          <div class="name">伙伴留言及疑问</div><span class="tip"></span>
        </div>
        <div class="textarea-box">
          <textarea placeholder="请输入留言及疑问(非必填)" maxlength="500" v-model="content" v-on:focus="focus()"
            v-on:blur="blur()"></textarea>
        </div>
      </div>

      <div class="section6">
        <div class="htitle" v-show="pageType==1">
          <div class="name">申请须知</div><span class="tip"></span>
        </div>
        <div class="htitle" v-show="pageType==2">
          <div class="name">伙伴须知</div><span class="tip"></span>
        </div>
        <div class="info" v-for="(value,index) in infos" :key="index">
          <div class="tip">{{index+1}}</div>
          <div class="name">{{value.title}}</div>
        </div>
      </div>
    </div>
    <bottomButton show="1" id="bottomButton" title="立即申请" :state="bottomState" @click="bottomClick"></bottomButton>
    <div id="captcha" :class="captchaConfig.config.product === 'bind' ? 'hideHeight' : ''">
      <AliCaptcha :captcha-config="captchaConfig" />
    </div>
    <!-- 成功弹窗 -->
    <!--    <SuccessView :show="showSuccessView" type="1" @successViewClick="successViewClick"></SuccessView>-->
  </div>
</template>

<script>
// import wxShare from '../wx/weixin.js'
import { Toast } from 'mint-ui'
import mainHeader from '../../view/header'
import bottomButton from '../../components/bottom-button'
import AliCaptcha from '../../components/aliCaptcha.vue'

export default {
  inject: ['reload'], // 界面刷新
  data () {
    const captchaHandler = (captchaObj) => {
      window.captchaObj = captchaObj;
      captchaObj
      .appendTo("#captcha")
      .onReady(function () {
        console.log("ready");
      })
      .onNextReady(function () {
        console.log("nextReady");
      })
      .onBoxShow(function () {
        console.log("boxShow");
      })
      .onError(function (e) {
        console.log(e);
      })
      .onSuccess(() => {
        console.log(window._vueInstance,'window._vueInstance')
        if (window._vueInstance && window._vueInstance.captchaConfig.config.product === "bind") {
          window._vueInstance.validate();
        }
      });
    };
    return {
      isLogin: 0,
      bottomState: 0,
      pageType: 1, // 1 获取方案  2 申请合作
      msgImg_n: require('../../assets/radio_n.png'),
      msgImg_s: require('../../assets/radio_s.png'),
      company_name: '',
      main_business: '',
      contacter: '',
      phone: '',
      code: '',
      isCode: 0, // 验证验证码 正确有效
      career: '',
      other: '',
      content: '',
      timer: '',
      type: '',
      typeswork: [ // 陈总,鲁总
        { title: '智慧消防大数据平台', isSel: 0, name: '陈总' },
        { title: '消防物联网平台', isSel: 0, name: '陈总' },
        { title: '智能运维平台', isSel: 0, name: '陈总' }
      ],
      typesplan: [
        { title: '技术服务合作', isSel: 0, name: '陈总' },
        { title: '实施服务合作', isSel: 0, name: '鲁总' },
        { title: '品牌供应合作', isSel: 0, name: '陈总' },
        { title: '其他服务合作', isSel: 0, name: '鲁总' }
      ],
      infos: [
        { title: '消防云保证您填写的信息不会泄露给第三方；' },
        { title: '表格填写完成后，我们将尽快安排工作人员与您联系；' }
      ],
      codeBtnClass: 'CodeDefault',
      captchaConfig: {
        config: {
          captchaId: "347c38155fea93f1450cab541186c39f",
          language: "zho",
          product: "bind",
        },
        handler: captchaHandler,
      },
    }
  },
  methods: {
    logoutClick: function () { // 退出登录
      this.$router.push({ path: 'home' })
    },
    goBackClick: function () {
      this.$router.go(-1)
    },
    blur: function () {
      if (this.utils.isIphone()) { // iphone 适配键盘 弹出 回弹
        const currentScrollY = window.scrollY
        window.scrollTo(0, currentScrollY)
      } else {
        document.getElementById('bottomButton').style.display = 'block'
      }
    },
    focus: function () {
      if (!this.utils.isIphone()) {
        document.getElementById('bottomButton').style.display = 'none'
      }
    },
    phoneCodeClick: function () {
      if (this.phone.length <= 0) {
        Toast('请输入联系方式')
        return
      }
      if (!this.utils.isPhone(this.phone)) {
        Toast('请正确输入联系方式')
        return
      }
      if (this.captchaConfig.config.product === 'bind') {
        // bind模式：弹出验证框，验证成功后由 onSuccess 回调触发 validate
        window.captchaObj.showCaptcha();
      } else {
        // 非bind模式：直接获取验证结果后发送短信
        this.validate();
      }
    },
    getCode: function (result) {
      var _this = this
      let params = {
        phone: this.phone,
        captchaOutput: result.captcha_output,
        genTime: result.gen_time,
        lotNumber: result.lot_number,
        passToken: result.pass_token
      }
      this.utils.POST(this.accountUrl + '/account/riskevalsms', params, function (response) {
        _this.countDown()
      })
    },
    validate () {
      let result = window.captchaObj.getValidate();
      if (!result) {
        alert('请先完成验证！');
        return;
      }
      var _this = this
      // 获取验证码之前 判断该手机号是否已经申请
      let param = 'phone=' + this.phone + '&type=' + (this.pageType === 1 ? '方案' : '合作')
      this.utils.GET(this.companyUrl + '/businessCooperation/isExist?' + param, function (response) {
        if (parseInt(response.code) === 0) {
        _this.getCode(result)
        }
      })
    },
    countDown: function () { // 倒计时
      console.log('倒计时==========')
      var maxtime = 60
      var _this = this
      this.timer = setInterval(function () {
        if (document.getElementById('cloud-plan') === null) {
          clearInterval(_this.timer)
          return
        }
        if (maxtime > 0) {
          --maxtime
          document.getElementById('cloudCodeText').innerText = maxtime + 's后重新获取'
          _this.codeBtnClass = 'CodeTimer'
        } else {
          clearInterval(_this.timer)
          document.getElementById('cloudCodeText').innerText = '重新获取'
          _this.codeBtnClass = 'CodeActive'
        }
      }, 1000)
    },
    typeClick: function (value) {
      if (value.isSel === 1) {
        value.isSel = 0
        this.type = this.type.replace(value.title, '')
      } else {
        value.isSel = 1
        this.type += value.title
      }
    },
    checkParam: function () {
      if (this.company_name.length <= 0) {
        Toast('请输入公司名称')
        return false
      }
      if (this.main_business.length <= 0) {
        Toast('请输入主营行业')
        return false
      }
      if (this.contacter.length <= 0) {
        Toast('请输入联系人姓名')
        return false
      }
      if (this.phone.length <= 0) {
        Toast('请输入联系人联系方式')
        return false
      }
      if (!this.utils.isPhone(this.phone)) {
        Toast('请正确输入联系人联系方式')
        return false
      }
      if (this.isCode === 0) {
        Toast('请正确输入验证码')
        return false
      }
      return true
    },
    bottomClick: function () {
      if (this.checkParam() === false) return

      var typeStr = ''
      var receiverStr = ''
      if (this.pageType === 1) {
        for (let i = 0; i < this.typeswork.length; i++) {
          let item = this.typeswork[i]
          if (item.isSel === 1) {
            typeStr += (item.title + ',')
            if (receiverStr.indexOf(item.name) === -1) {
              receiverStr += (item.name + ',')
            }
          }
        }
      }
      if (this.pageType === 2) {
        for (let i = 0; i < this.typesplan.length; i++) {
          let item = this.typesplan[i]
          if (item.isSel === 1) {
            typeStr += (item.title + ',')
            if (receiverStr.indexOf(item.name) === -1) {
              receiverStr += (item.name + ',')
            }
          }
        }
      }
      if (this.pageType === 1 && typeStr.length <= 0) {
        Toast('请选择方案类型')
        return false
      }
      if (this.pageType === 2 && typeStr.length <= 0) {
        Toast('请选择合作类型')
        return false
      }
      typeStr = typeStr.substr(0, typeStr.length - 1)
      receiverStr = receiverStr.substr(0, receiverStr.length - 1)

      var param = {
        company_name: this.company_name,
        main_business: this.main_business,
        contacter: this.contacter,
        phone: this.phone,
        title: this.career,
        other: this.other,
        content: this.content,
        type: typeStr,
        receiver: receiverStr
      }
      console.log(param)

      var _this = this
      this.utils.POST(this.companyUrl + '/businessCooperation/save', param, function (response) {
        if (response.code === 0) {
          Toast('提交成功')
          clearInterval(_this.timer)
          setTimeout(function () {
            _this.$router.go(-1)
          }, 2000)
        }
      })
    }
  },
  components: {
    mainHeader,
    bottomButton,
    AliCaptcha
  },
  watch: { // 计算
    isActive: function (val) {
      if (val === true) {
        this.bottomState = 1
      } else {
        this.bottomState = 0
      }
    },
    phone: function (val) {
      if (val.length > 0) {
        this.codeBtnClass = 'CodeActive'
      } else {
        this.codeBtnClass = 'CodeDefault'
      }
    },
    code: function (val) {
      if (val.length === 6) {
        let param = {
          phone: this.phone,
          code: this.code
        }
        var _this = this
        this.utils.POST(this.accountUrl + '/account/verifyCode', param, function (response) {
          if (response.data.data === true) {
            // _this.showSuccessView = true
            _this.isCode = 1
          }
        })
      }
    }
  },
  computed: { // 计算
    isActive: function () {
      if (this.company_name.length > 0 && this.main_business.length > 0 && this.contacter.length > 0 &&
        this.phone.length > 0 && this.code.length > 0 && this.type.length > 0) {
        return true
      }
      return false
    }
  },
  mounted () {
    window._vueInstance = this;
    window.pageYOffset = 0
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0

    // 登录状态
    this.pageType = parseInt(this.$route.query.type)
    let index = parseInt(this.$route.query.ctype)

    var _this = this
    this.utils.isUserLogin(function (login) {
      if (login === 1) {
        _this.isLogin = 1
        let userInfo = JSON.parse(localStorage.getItem('userinfo'))
        console.log(userInfo)
        _this.phone = userInfo.tails.userinfo[0].phone
        if (userInfo.ent_name !== undefined) {
          _this.company_name = userInfo.ent_name
        }
      } else {
        _this.$router.push({ path: 'login', query: { back: 1 } })
        console.log('登录===' + _this.isLogin)
        Toast('请先登录！')
      }
    })
    // 已选择类型
    if (this.pageType === 2 && index >= 0) {
      for (let i = 0; i < this.typesplan.length; i++) {
        if (index === i) {
          this.typesplan[i].isSel = 1
          this.type = this.typesplan[i].title
        }
      }
    }
  }
}

</script>

<style scoped>
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.title-header {
  position: fixed;
  top: 55px;
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  z-index: 1000;
}
.title-header .title {
  height: 50px;
  line-height: 50px;
  color: #000;
  font-size: 15px;
  font-weight: bold;
  margin-left: 15px;
}
.title-header .right {
  position: absolute;
  right: 15px;
  height: 50px;
  line-height: 50px;
  color: #999999;
  font-size: 13px;
}
.wrapper {
  /*background-color: #F6F6F6;*/
  /*background-color: #FFEECC;*/
  background-color: #eeeeee;
  /*margin-top: 55px;*/
  padding-top: 115px;
  padding-bottom: 70px;
}
.section1 {
  position: relative;
  width: 100%;
  height: 90px;
  background-image: url(./images/icon_cloud_plan.png);
  background-size: cover;
  background-position: center;
}
.section1 .title {
  position: absolute;
  left: 15px;
  top: 20px;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}
.section2 {
  position: relative;
  width: 100%;
  height: 165px;
  background-color: #ffffff;
  box-sizing: content-box;
  border-bottom: #eeeeee solid 10px;
}
.section3 {
  position: relative;
  width: 100%;
  height: 330px;
  background-color: #ffffff;
  box-sizing: content-box;
  border-bottom: #eeeeee solid 10px;
}
.section2 .input-box,
.section3 .input-box {
  position: relative;
  width: 100%;
  height: 55px;
  line-height: 55px;
  box-sizing: border-box;
  border-bottom: #eeeeee solid 1px;
}
.section2 .input-box span,
.section3 .input-box span {
  padding-left: 15px;
  width: 100px;
  font-size: 15px;
  color: #323232;
}
.section2 .input-box input,
.section3 .input-box input {
  position: absolute;
  top: 10px;
  left: 120px;
  width: calc(100% - 145px);
  height: 34px;
  line-height: 34px;
  font-size: 15px;
  color: #000000;
  box-sizing: border-box;
  border: none;
  /*background-color: antiquewhite;*/
}
.input-box .button {
  position: absolute;
  right: 15px;
  top: 13px;
  text-align: center;
  min-width: 80px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 14px;
  font-size: 14px;
  /*color: #ffffff;*/
  /*background-color: #c41335;*/
  padding: 0 10px;
}

.section4 {
  position: relative;
  width: 100%;
  /*height: 275px;*/
  min-height: 200px;
  background-color: #ffffff;
  box-sizing: content-box;
  border-bottom: #eeeeee solid 10px;
  padding-bottom: 20px;
}
.section4 .check-box {
  position: relative;
  top: 8px;
  left: 15px;
  width: calc(100% - 110px);
  height: 48px;
  line-height: 48px;
  font-size: 15px;
  color: #000000;
  box-sizing: border-box;
  border: none;
}
.section4 .check-box img {
  position: absolute;
  left: 0px;
  width: 22px;
  height: 22px;
  top: 14px;
  object-fit: cover;
}
.section4 .check-box span {
  position: absolute;
  left: 35px;
  line-height: 48px;
  font-size: 15px;
  color: #000000;
}

.section5 {
  position: relative;
  width: 100%;
  height: 190px;
  background-color: #ffffff;
  box-sizing: content-box;
  border-bottom: #eeeeee solid 10px;
}
.section5 .textarea-box {
  position: absolute;
  top: 70px;
  left: 15px;
  width: calc(100% - 30px);
  height: 100px;
  border: solid #eeeeee 1px;
  box-sizing: border-box;
}

.section5 .textarea-box textarea {
  position: absolute;
  left: 5px;
  top: 5px;
  width: calc(100% - 8px);
  height: 90px;
  line-height: 20px;
  font-size: 14px;
  color: #000000;
  border: none;
}

.section6 {
  position: relative;
  min-height: 150px;
  background-color: #ffffff;
  box-sizing: content-box;
  border-bottom: #eeeeee solid 10px;
  padding-bottom: 15px;
}
.section6 .info {
  position: relative;
  top: 10px;
  left: 0px;
  width: 100%;
  min-height: 30px;
  font-size: 14px;
  color: #000000;
  margin-bottom: 10px;
  box-sizing: content-box;
}
.section6 .info .tip {
  position: relative;
  margin-top: 12px;
  margin-left: 15px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  color: #ffffff;
  background-color: #c41335;
  border-radius: 8px;
  text-align: center;
  font-size: 12px;
}
.section6 .info .name {
  position: relative;
  margin-top: -21px;
  margin-left: 38px;
  margin-right: 10px;
  line-height: 25px;
  font-size: 15px;
  color: #000000;
}

.htitle {
  position: relative;
  width: 100%;
  height: 55px;
  border-bottom: solid 1px #eeeeee;
  box-sizing: border-box;
}
.htitle .name {
  position: absolute;
  top: 5px;
  left: 15px;
  height: 50px;
  line-height: 50px;
  color: #000000;
  font-size: 15px;
  font-weight: bold;
  border-bottom: solid 3px #c41335;
  box-sizing: border-box;
}
.htitle .tip {
  position: absolute;
  top: 4px;
  left: 140px;
  height: 50px;
  line-height: 50px;
  color: #bebebe;
  font-size: 12px;
}
.htitle .tip2 {
  position: absolute;
  top: 4px;
  left: 110px;
  height: 50px;
  line-height: 50px;
  color: #bebebe;
  font-size: 12px;
}
.CodeDefault {
  background-color: #fecdcd;
  color: #ffffff;
}
.CodeActive {
  background-color: #c41335;
  color: #ffffff;
}
.CodeTimer {
  background-color: #ffffff;
  color: #bebebe;
}
</style>



// WEBPACK FOOTER //
// src/view/cloud/plan.vue